import "./Main.css";
import React, { useEffect, useState } from "react";
import { Title } from "../../Components/Title/Title";
import { Candidate } from "../../Classes/Candidate";
import { axiosCandidateConnected } from "../../Services/CandidateService";
import { axiosStartupPage } from "../../Services/StartupService";
import { Paper } from "@material-ui/core";
import Header from "../../Components/Header/Header";
import Description from "../../Components/Description/Description";
import Footer from "../../Components/Footer/Footer";
import { createTemplateInstance } from "../../Classes/Templates/Template";
import Skeleton from "react-loading-skeleton";
import Form from "../../Components/Form/Form";
import { CandidateCampaignResponse } from "../../Classes/CandidateCampaignResponse";
import { TemplateModel } from "../../Classes/TemplateModel";
import { MainModel } from "../../Classes/MainModel";
import { DescriptionModel } from "../../Classes/DescriptionModel";
import { TemplateInstance } from "../../Classes/TemplateInstance";
import { useNavigate } from "react-router-dom";
import { ResponseType } from "../../Classes/Enums/ResponseType";

const Main = (props: MainModel) => {
  const navigate = useNavigate();
  document.documentElement.dir = "rtl";
  const [description, setDescription] = useState<
    DescriptionModel | undefined
  >();
  const [campaignData, setCampaignData] = useState<
    CandidateCampaignResponse | undefined
  >();
  const [template, setTemplate] = useState<TemplateInstance | null>(null);
  const [image, setImage] = useState<string>("");
  const [showFullText, setShowFullText] = useState(false);
  const [view, setView] = useState<React.ReactNode>(null);
  const [showContinue, setShowContinue] = useState(false);

  let candidate: Candidate;
  let candidateInfo: Candidate | null;

  const paperStyle = {
    height: "auto",
    width: "auto",
    maxWidth: "100%",
    margin: "2% 2%",
    boxShadow: "0 0 20px 0 rgba(0, 0, 0, 0.2), 0 5px 5px 0 rgba(0, 0, 0, 0.24)",
    borderRadius: "5px",
  };

  const loadPage = async () => {
    if (props.CandidateId != null) {
      candidateInfo = await axiosCandidateConnected(props.CandidateId);
      if (candidateInfo && candidateInfo.CandidateId) {
        candidate = new Candidate(
          candidateInfo.FullName,
          candidateInfo.CandidateId
        );
      }
    }

    let startupData;
    startupData = await axiosStartupPage(props.CampaignId || "");
    if (startupData == null) navigate("/error");

    setDescription(
      new DescriptionModel(
        startupData?.ListTitle,
        startupData?.ListParagraphOne,
        startupData?.ListParagraphTwo
      )
    );

    if ((await validateGuid(props.CampaignId || "")) === false) {
      window.location.href =
        window.location.href.slice(0, window.location.href.indexOf("/", 10)) +
        "/error";
    }

    if (startupData != null)
      await templateHandler(startupData.TemplateInformation);

    const newCampaignData = new CandidateCampaignResponse(
      candidateInfo?.CandidateId,
      props.CampaignId,
      ResponseType.NotInterested,
      // startupData?.ReferrerTypeId,
      startupData?.ReferrerId
      // startupData?.SubReferrerDetailId
    );
    setCampaignData(newCampaignData);

    if (candidateInfo) {
      setView(<Footer {...newCampaignData} />);
    } else {
      setView(<Form {...newCampaignData} />);
    }

    const textDiv = document.getElementsByClassName("job-information")[0];
    if (textDiv.scrollHeight > textDiv.clientHeight) {
      setShowContinue(true);
    } else {
      setShowContinue(false);
    }
  };

  const validateGuid = async (guid: string) => {
    var pattern =
      /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;
    if (pattern.test(guid)) return true;
    return false;
  };

  const templateHandler = async (templateInformation: TemplateModel) => {
    var template = await createTemplateInstance(templateInformation);

    setImage(template.ImageIdentifier || "");
    setTemplate(template);
  };

  useEffect(() => {
    loadPage();
  }, []);

  return (
    <div className="container main-container">
      <Paper style={paperStyle}>
        <div className="col header">
          <Header />
        </div>
        <div className="col title">
          {template ? (
            <Title
              FirstText={template.FirstText}
              SecondText={template.SecondText}
            />
          ) : (
            <Skeleton
              count={2}
              height={25}
              direction="rtl"
              width="80%"
              style={{ lineHeight: "30px" }}
            />
          )}
        </div>
        <div className="col main-image">
          {image ? (
            <img
              src={require(`../../Images/${image}.png`)}
              width="90%"
              height="100%"
              alt=""
            />
          ) : (
            <Skeleton
              count={1}
              height={100}
              width="90%"
              direction="rtl"
              style={{ lineHeight: "100px" }}
            />
          )}
        </div>
        <div
          className={`job-information ${
            showFullText ? "full-job-information" : "job-information"
          }`}
        >
          <Description {...description} />
        </div>
        {showContinue ? (
          <div
            className="col continue-button"
            onClick={() => setShowFullText(true)}
          >
            <div
              className={`show-continue ${
                showFullText ? `dont-show-continue` : "show-continue"
              }`}
            >
              {document.documentElement.dir === "rtl" ? (
                <span>
                  להמשך<i className="description-arrow left"></i>
                </span>
              ) : (
                <span>
                  {" "}
                  <i className="description-arrow left"></i>להמשך
                </span>
              )}
            </div>
          </div>
        ) : null}
        {view ? (
          <div className="col footer">{view}</div>
        ) : (
          <div className="row">
            <div className="col skeleton-load">
              <Skeleton
                count={1}
                height={100}
                width="100%"
                direction="rtl"
                style={{ lineHeight: "100px" }}
              />
            </div>
          </div>
        )}
      </Paper>
    </div>
  );
};

export default Main;
